import { IApp04AIChat } from "./App04AIChat";
import { Entity, IEntity } from "./Entity";
import { IUser } from "./User";

export interface IApp04AIChatUser extends IEntity {
    UserID?: number;
    ChatID?: number;
    User?: IUser;
    Chat?: IApp04AIChat;
}

export class App04AIChatUser extends Entity implements IApp04AIChatUser {
    public UserID = null;
    public ChatID = null;
    public Chat = null;

    constructor() {
        super();
    }
}